import styled from 'react-emotion'
import themeVars from 'ui_theme/site/globals/site.variables'

export default styled('div')`
  padding-left: ${themeVars.mini};
  color: ${themeVars.ultraLight};
`
